import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { catchError, tap } from 'rxjs/operators';
import { INewTask } from '../classes/new-task';
import { OtherParking } from './../classes/other-parking';
import { RemoteParking } from './../classes/remote-parking';
import { ConfigurationService } from './configuration.service';
import { LoggerService } from './logger.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class NewTaskService {

  private buildTaskResponse$: BehaviorSubject<INewTask> = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private toastService: ToastService,
    private configurationService: ConfigurationService) {}

  buildTask(payload: RemoteParking | OtherParking): Observable<HttpResponse<any>> {
    const config = this.configurationService.configuration$.getValue();
    if (!config) {
      return throwError(new Error('Configuration not loaded'));
    }
    const url = config.HostApi.concat('/task');
    return this.http
      .post<INewTask>(url, payload, {
        headers: new HttpHeaders({"Content-Type": "application/json"}),
        observe: "response"
      })
      .pipe(
        tap((resp) => {
          const _resp: HttpResponse<any> = resp;
          const task: any = _resp.body;
          this.updateTaskResponse(task);
        }),
        catchError((error: HttpErrorResponse) => this.handleError(error, 'Failed to build task'))
      );
  }

  updateTaskResponse(data: any): void {
    this.buildTaskResponse$.next(data);
  }

  private handleError(error: HttpErrorResponse, message: string) {
    this.toastService.show('HTTP Error Occurred!', { classname: 'bg-danger text-light', delay: 8000 });
    if (error.status === 0) {
      this.logger.error(`${message}:`, error.error);
    } else {
      this.logger.error(`${message}: ${error.status}, body was: ${error.error}`);
    }
    return throwError(error);
  }
}
